export const GET_MY_TASKS_REQUEST = 'GET_MY_TASKS_REQUEST';
export const GET_MY_TASKS_SUCCESS = 'GET_MY_TASKS_SUCCESS';
export const GET_MY_TASKS_FAIL = 'GET_MY_TASKS_FAIL';

export const MARK_TASK_COMPLETED_REQUEST = 'MARK_TASK_COMPLETED_REQUEST';
export const MARK_TASK_COMPLETED_SUCCESS = 'MARK_TASK_COMPLETED_SUCCESS';
export const MARK_TASK_COMPLETED_FAIL = 'MARK_TASK_COMPLETED_FAIL';

export const getMyTasksRequest = (userId, roleId) => ({
    type: GET_MY_TASKS_REQUEST,
    payload: { userId, roleId }
});

export const getMyTasksSuccess = (tasks) => ({
    type: GET_MY_TASKS_SUCCESS,
    payload: tasks
});

export const getMyTasksFail = (error) => ({
    type: GET_MY_TASKS_FAIL,
    error
});

export const markTaskCompletedRequest = (taskId) => ({
    type: MARK_TASK_COMPLETED_REQUEST,
    payload: { taskId }
});

export const markTaskCompletedSuccess = (taskId) => ({
    type: MARK_TASK_COMPLETED_SUCCESS,
    payload: { taskId }
});

export const markTaskCompletedFail = (error) => ({
    type: MARK_TASK_COMPLETED_FAIL,
    error
});
